import axios, { type AxiosError, type AxiosInstance } from 'axios';

import { env } from '../env';

export const api: AxiosInstance = axios.create({
  baseURL: `${env.VITE_API_URL}/api`,
  withCredentials: true,
  timeout: 30_000,
});

let onUnauthenticated: (() => void) | null = null;
export function setUnauthenticatedHandler(fn: () => void) {
  onUnauthenticated = fn;
}

api.interceptors.response.use(
  (r) => r,
  (error: AxiosError) => {
    if (error.response?.status === 401 && onUnauthenticated) {
      onUnauthenticated();
    }
    return Promise.reject(error);
  },
);

export interface ApiError {
  code: string;
  message: string;
  details?: unknown;
}

export function extractApiError(err: unknown): ApiError {
  if (axios.isAxiosError(err) && err.response?.data) {
    const data = err.response.data as Partial<ApiError>;
    return {
      code: data.code ?? 'UNKNOWN',
      message: data.message ?? 'Something went wrong',
      details: data.details,
    };
  }
  return { code: 'UNKNOWN', message: 'Network error' };
}

export function errorMessage(err: unknown): string {
  return extractApiError(err).message;
}
